$(document).ready(function() {
  $('.info-new-users').tooltip();
});

